<template lang="pug">
v-sheet(height='70vh').pa-3.d-flex
  v-col(cols=12 lg=6).pa-0
    infinity-scroll-list(
      ref="infinityScroll"
      v-model="selected"
      :method="adapter"
      :filters="filters"
      :is-mobile="isMobile"
      :pagination="pagination"
    )
      template(#list-item="{item, index }")
        slot(name="list-item" v-bind="{ item, index }")

  v-col.pa-0.pl-4(cols=6 v-if="!isMobile")
    v-expand-transition
      v-card.sdo-card.mb-4(
        :key="`${selected.id}`" height="100%" v-if="selected"
      )
        v-card-text.pb-2(style="height:100%").overflow-y-auto.scroll
          component(
            :item="selected"
            :is="detailsComponent.component"
            v-bind="detailsComponent.component_attrs"
            v-on="detailsComponent.component_listeners"
          )
      v-alert(v-else type="info" outlined) Выберите элемент списка для детального отображения
  v-navigation-drawer(
    app
    v-else
    v-model="drawer"
    right
    temporary
    width="90%"
    height="100%"
  )
    v-card.sdo-card(
      v-if="selected"
      :key="`${selected.id} ${detailsComponent.key}`"
      height='100%'
    ).pa-2.d-flex.flex-column
      component.overflow-auto(
        :is="detailsComponent.component"
        :detailsItem="selected"
        :item="selected"
        v-bind="detailsComponent.component_attrs"
        v-on="detailsComponent.component_listeners"
      )
</template>

<script>
import InfinityScrollList from './components/InfinityScrollList.vue';

export default {
  components: {
    InfinityScrollList,
  },
  props: {
    detailsComponent: { type: Object, required: true },
    adapter: { type: Function, required: true },
    methods: { type: Object, default: null },
    pagination: { type: Boolean, default: false },
    filters: { type: Array, default: () => ([]) },
    showChips: { type: Boolean, default: false },
  },
  data() {
    return {
      drawer: false,
      selected: null,
      selectedItem: null,
    };
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.mobile;
    },
  },
  watch: {
    drawer(val) {
      if (!val) this.selected = null;
    },
    async selected(val) {
      if (val) {
        this.drawer = true;
        this.$emit('change');
      }
    },
  },
  methods: {
    refreshList() {
      this.$refs.infinityScroll.$refs.list.init();
    },
    confirmDelete() {
      this.$modals.show('confirm-controller', {
        title: 'Подтвердите удаление',
        dialogProps: {
          width: 800,
        },
        method: async () => {
          await this.methods.delete(this.selected.id);
          this.selected = null;
          this.refreshList();
        },
      });
    },
  },
};
</script>
